import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86b57934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-organizations-detail-members" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Članovi ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "role" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = {
  key: 0,
  class: "action"
}
const _hoisted_13 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorOrganizationsDetailMembersFormCreateIndexVue = _resolveComponent("AppAdministratorOrganizationsDetailMembersFormCreateIndexVue")!
  const _component_AppAdministratorOrganizationsDetailMembersFormUpdateIndexVue = _resolveComponent("AppAdministratorOrganizationsDetailMembersFormUpdateIndexVue")!
  const _component_AppAdministratorOrganizationsDetailMembersFormRemoveIndexVue = _resolveComponent("AppAdministratorOrganizationsDetailMembersFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorOrganizationsDetailMembersFormCreateIndexVue, {
          organizationMembers: _ctx.organizationMembers,
          onGetOrganizationMembers: _ctx.getOrganizationMembers
        }, null, 8, ["organizationMembers", "onGetOrganizationMembers"])
      ]),
      (_ctx.organizationMembers.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.organizationMembers, (organizationMember) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: organizationMember.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(organizationMember.user.content.name) + " " + _toDisplayString(organizationMember.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, [
                    (organizationMember.role === 'administrator')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Administrator"))
                      : _createCommentVNode("", true),
                    (organizationMember.role === 'coach')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Trener"))
                      : _createCommentVNode("", true),
                    (organizationMember.role === 'player')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Igrač"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!_ctx.isAdministrator(organizationMember.user_id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createVNode(_component_AppAdministratorOrganizationsDetailMembersFormUpdateIndexVue, {
                        organizationMember: organizationMember,
                        onGetOrganizations: _ctx.getOrganizationMembers
                      }, null, 8, ["organizationMember", "onGetOrganizations"]),
                      _createVNode(_component_AppAdministratorOrganizationsDetailMembersFormRemoveIndexVue, {
                        organizationMember: organizationMember,
                        onGetOrganizations: _ctx.getOrganizationMembers
                      }, null, 8, ["organizationMember", "onGetOrganizations"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, " Nema podataka... "))
    ])
  ]))
}